import api from "@/lib/api";

export const NAME = { POWER: "Power", GAS: "Gas" };
export const GAS_UNITS = { mwh: "€/MWh", smc: "€/Smc", csmc: "c€/Smc" };
export const num = (t) => { const s = String(t ?? "").trim(); if (!s) return null; const n = Number(s.replace(",", ".")); return Number.isNaN(n) ? NaN : n; };
export const str = (v, d = 3) => (v == null ? "" : String(Math.round(v * 10 ** d) / 10 ** d).replace(".", ","));
export const unitOf = (commodity, gasUnit) => (commodity === "POWER" ? "€/MWh" : GAS_UNITS[gasUnit]);
export const priceDigits = (unit) => (unit === "€/Smc" ? 4 : 2);
export const errMsg = (e, fb) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : fb; };

export async function downloadBlob(path, params, filename) {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  Object.assign(document.createElement("a"), { href: url, download: filename }).click();
  URL.revokeObjectURL(url);
}

export async function downloadPost(path, body, params, filename) {
  const r = await api.post(path, body, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  Object.assign(document.createElement("a"), { href: url, download: filename }).click();
  URL.revokeObjectURL(url);
}
